import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const LanguageButton = styled(Button)({
  minWidth: '80px',
  textTransform: 'none'
});

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    handleClose();
  };

  const getLanguageLabel = (lang) => {
    switch (lang) {
      case 'zh':
        return '中文';
      case 'en':
        return 'English';
      default:
        return '中文';
    }
  };

  return (
    <div>
      <LanguageButton
        variant="outlined"
        onClick={handleClick}
      >
        {getLanguageLabel(i18n.language)}
      </LanguageButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleLanguageChange('zh')}>中文</MenuItem>
        <MenuItem onClick={() => handleLanguageChange('en')}>English</MenuItem>
      </Menu>
    </div>
  );
}

export default LanguageSwitcher;